"use client"
import React, { createRef } from "react"
import PT from "prop-types"
import { Spin, Typography } from "antd"
import styles from "./ListingsFilter.module.scss"
import compStyles from "@css/Components.module.scss"
import { TagsList } from "./components/ListingsFilterCheckboxList"
import { addCurrency, getMonthNum } from "@utils/index"
import Nouislider from "nouislider-react"
import "nouislider/dist/nouislider.css"
import { brokerNotActiveStatuses, originNames, ownImplicitActiveStatuses, ownNotActiveStatuses } from "@utils/const"
import { filtersState } from "@utils/FiltersState"
import { observer } from "@utils/observer"
import { Toggle } from "../../Toggle"
import { ArrowLeft } from "@css/icons/SVG"
import cn from "classnames"
import Image from "next/image"
import { originImgURL } from "../listings-page-utils"
import { initialFilters, rangeMaxValues } from "./const"
import { StarsSelect } from "./components/StarsSelect"
import { withHooksToProps } from "@utils/hooks/withHooksToProps"
import { FEATURE_FLAGS, useFlags } from "@contexts/FeatureFlagContext"
import { useRouter } from "next/navigation"

const { Title } = Typography

function formatTooltip(max) {
    return (val) => {
        return val > max ? "Max" : addCurrency(val)
    }
}

function addSelected(target, src = []) {
    target.forEach((i) => {
        i.selected = src.includes(i.key)
    })
    return target
}

const origins = [
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["dvcresalemarket"]} alt="dvcresalemarket" width="22" height="22" />
                {originNames.dvcresalemarket}
            </>
        ),
        key: "dvcresalemarket"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["dvcshop"]} alt="dvcshop" width="22" height="22" />
                {originNames.dvcshop}
            </>
        ),
        key: "dvcshop"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["dvcstore"]} alt="dvcstore" width="22" height="22" />
                {originNames.dvcstore}
            </>
        ),
        key: "dvcstore"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["fidelityresales"]} alt="fidelityresales" width="22" height="22" />
                {originNames.fidelityresales}
            </>
        ),
        key: "fidelityresales"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["dvcresaleexperts"]} alt="dvcresaleexperts" width="22" height="22" />
                {originNames.dvcresaleexperts}
            </>
        ),
        key: "dvcresaleexperts"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["dvcsales"]} alt="dvcsales" width="22" height="22" />
                {originNames.dvcsales}
            </>
        ),
        key: "dvcsales"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["resalesdvc"]} alt="resalesdvc" width="22" height="22" />
                {originNames.resalesdvc}
            </>
        ),
        key: "resalesdvc"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["dvcbyresale"]} alt="dvcbyresale" width="22" height="22" />
                {originNames.dvcbyresale}
            </>
        ),
        key: "dvcbyresale"
    },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["vacatia"]} alt="vacatia" width="22" height="22" />
                {originNames.vacatia}
            </>
        ),
        key: "vacatia"
    },
    // {
    //     children: (
    //         <>
    //             <Image className={styles.partnerImg} src={originImgURL["dvctimeshares"]} alt="dvctimeshares" width="22" height="22" />
    //             {originNames.dvctimeshares}
    //         </>
    //     ),
    //     key: "dvctimeshares"
    // },
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["dvcadvantages"]} alt="dvcadvantages" width="22" height="22" />
                {originNames.dvcadvantages}
            </>
        ),
        key: "dvcadvantages"
    },
    /*    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["atimeshare"]} alt="atimeshare" width="22" height="22" />
                A timeshare
            </>
        ),
        key: "atimeshare"
    },*/
    {
        children: (
            <>
                <Image className={styles.partnerImg} src={originImgURL["buyandselldvc"]} alt="buyandselldvc" width="22" height="22" />
                {originNames.buyandselldvc}
            </>
        ),
        key: "buyandselldvc"
    }
]

let timerIndex

class ListingsFilter extends React.Component {
    static propTypes = {
        filterData: PT.object,
        onChange: PT.func
    }
    filters = {}
    initialFilters = initialFilters
    memoCallback = {}
    state = {
        display: true,
        activeOnly: true,
        open: false
    }

    minRef = createRef()
    maxRef = createRef()

    constructor(props) {
        super(props)
        this.allowUpdate = false
        this.initialize(props)
    }
    getFilters = () => {
        return filtersState.getFilter(this.props.pathname)
    }
    setFilters = (data) => {
        filtersState.setFilter(data, this.props.pathname)
    }

    initialize = (props) => {
        this.initialFilters = initialFilters
        const use_month = (props.filterData?.listingFilter?.use_month?.split(",") || []).map((i) => ({ key: i }))
        const listing_status = (props.filterData?.listingFilter?.listing_status?.split(";") || []).map((i) => ({ key: i }))
        const broker_status = (props.filterData?.listingFilter?.broker_status?.split(";") || []).map((i) => ({ key: i }))

        this.ownNotActiveStatuses = [...ownNotActiveStatuses]
        let filters = this.getFilters()
        if (!filters?.hasOwnProperty("listing_status_nin")) {
            this.setFilters({
                listing_status_nin: this.ownNotActiveStatuses
            })
            this.state.activeOnly = true
        } else {
            this.state.activeOnly = !!filters.listing_status_nin?.length
        }
        this.initialFilters.listing_status_nin = this.ownNotActiveStatuses
        if (props.resort) {
            // setting default resort on "resorts/:slug/listings"
            this.setFilters({
                resort: props.resort
            })
        } else if (typeof filters.resort === "string") {
            this.setFilters({
                resort: undefined
            })
        }
        this.filters = {
            ...this.initialFilters,
            ...Object.keys(filters).reduce((res, key) => {
                if (typeof filters[key] !== "undefined") {
                    // apply none undefined values
                    res[key] = filters[key]
                }
                return res
            }, {})
        }

        const selectedResorts = filters.resort?.short_name_in || []
        const selectedUseYear = filters.use_month_in || []
        const selectedListingStatus = filters.listing_status_in || []
        const selectedBrokerStatus = filters.broker_status_in || []
        const selectedOrigins = filters.origin_in || []
        this.stars = filters.stars_gte || 1
        this.resortNames = [
            ...props.filterData.disneyResorts.map((i) => ({ key: i.short_name, group: "Walt Disney World Locations" })),
            ...props.filterData.nonDisneyResorts.map((i) => ({ key: i.short_name, group: "Other Club Resort Locations" }))
        ]
        this.listing_status = listing_status.filter((i) => !ownNotActiveStatuses.includes(i.key) && !ownImplicitActiveStatuses.includes(i.key))
        this.broker_status = broker_status.filter((i) => !brokerNotActiveStatuses.includes(i.key))
        this.use_month = use_month.sort((a, b) => getMonthNum(a.key) - getMonthNum(b.key))
        this.origin = [...origins]
        addSelected(this.resortNames, selectedResorts)
        addSelected(this.listing_status, selectedListingStatus)
        addSelected(this.broker_status, selectedBrokerStatus)
        addSelected(this.use_month, selectedUseYear)
        addSelected(this.origin, selectedOrigins)
    }

    componentDidMount() {
        this.allowUpdate = true
        setTimeout(() => {
            !this._unmounted && this.props.onChange(this.getFilters())
        }, 100)
        this.unobserve = observer.watch("listingsFilterOpen", () => {
            this.setState(
                {
                    open: !this.state.open
                },
                () => document.body.classList.add(styles.noScroll)
            )
        })
    }
    UNSAFE_componentWillUpdate(nextProps) {
        if (this.props.loading && !nextProps.loading) {
            this.initialize(nextProps)
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.props.loading && prevProps.loading) {
            this.props.onChange(this.getFilters())
        }
        if (!this.state.open && prevState.open) {
            document.body.classList.remove(styles.noScroll)
        }
    }

    componentWillUnmount() {
        this._unmounted = true
        this.unobserve()
        document.body.classList.remove(styles.noScroll)
    }

    componentDidCatch(error, errorInfo) {
        console.log(error, errorInfo)
    }

    updateFilter = (val = undefined) => {
        if (!this.allowUpdate) return
        clearInterval(timerIndex)
        this.setFilters(val)
        observer.trigger("saveSearchNotify")
        timerIndex = setTimeout(() => !this._unmounted && this.props.onChange(this.getFilters()), 150)
    }

    /**
     * @param key
     * @param maxValue
     * @returns {function(tooltip: any,nup: any,val: number[])}
     */
    onRangeChange = (key, maxValue) => {
        const memoName = `onRangeChange${key}${maxValue}`
        if (this.memoCallback[memoName]) {
            return this.memoCallback[memoName]
        }
        const memo = (tooltip, nup, [val1, val2]) => {
            let res
            const value1 = Math.round(val1)
            const value2 = val2 && Math.round(val2)
            if (value2) {
                res = {
                    [key + "_gte"]: value1,
                    [key + "_lte"]: value2 > maxValue ? undefined : value2
                }
            } else {
                res = {
                    [key + "_lte"]: value1 > maxValue ? undefined : value1
                }
            }
            this.updateFilter(res)
        }
        this.memoCallback[memoName] = memo
        return memo
    }

    onStarsChange = (value) => {
        this.updateFilter({
            stars_gte: value
        })
    }
    /**
     * @param key
     * @return {function(value:string[]) }
     */
    onTagListChange = (key) => {
        const memoName = "onTagListChange" + key
        if (this.memoCallback[memoName]) {
            return this.memoCallback[memoName]
        }
        /**
         * @param value {string[]}
         */
        const memo = (value) => {
            const filters = this.getFilters()
            const keyName = key + "_in"

            filters[keyName] = value?.length ? value : undefined
            this[key] = addSelected([...this[key]], filters[keyName] || [])
            this.updateFilter()
        }
        this.memoCallback[memoName] = memo
        return memo
    }
    onListChangeResort = (value) => {
        const filters = this.getFilters()
        if (!filters.resort?.short_name_in) {
            filters.resort = { short_name_in: [] }
        }
        filters.resort.short_name_in = value
        this.resortNames.forEach((i) => {
            i.selected = !!value?.some((j) => i.key === j)
        })
        this.resortNames = [...this.resortNames]
        const resorts = value.join(",")
        const search = new URLSearchParams(location.search)
        if (resorts) {
            search.set("resorts", resorts)
            search.delete("filter")
        } else {
            search.delete("resorts")
        }
        const searchString = search.toString() ? "?" + search.toString() : ""
        this.props.router.replace(location.pathname + searchString, { shallow: true, scroll: false })
        this.updateFilter()
    }

    clearAll = () => {
        filtersState.clear()
        this.filters = { ...this.initialFilters }
        if (this.props.resort) {
            this.setFilters({
                resort: this.props.resort
            })
        }
        this.stars = 1
        this.setDisplay(false)
        this.listing_status.forEach((i) => {
            i.selected = false
        })
        this.broker_status.forEach((i) => {
            i.selected = false
        })
        this.resortNames.forEach((i) => {
            i.selected = false
        })
        this.use_month.forEach((i) => {
            i.selected = false
        })
        this.origin.forEach((i) => {
            i.selected = false
        })
        this.updateFilter({
            listing_status_nin: this.ownNotActiveStatuses
        })
        /*this.updateFilter({
            broker_status_nin: this.brokerNotActiveStatuses
        })*/
        this.props.router.replace(location.pathname, { shallow: true, scroll: false })
        this.setState({
            activeOnly: true,
            open: false
        })
        setTimeout(() => {
            this.setDisplay(true)
        }, 100)
    }

    setDisplay = (val) => this.setState({ display: val })

    onInactiveChange = (checked) => {
        const listing_status_nin = checked ? undefined : this.ownNotActiveStatuses
        this.updateFilter({ listing_status_nin })
        this.setState({
            activeOnly: !checked
        })
    }

    formatterProxy = (isMin, val) => {
        const result = val > 1500 ? "Max" : Math.round(val)
        if (isMin) {
            this.minRef.current.innerText = result
        } else {
            this.maxRef.current.innerText = result
        }
        return result
    }

    formatter = [{ to: this.formatterProxy.bind(this, true) }, { to: this.formatterProxy.bind(this, false) }]

    getFilterContent = () => {
        if (!this.state.display || this.props.loading) {
            return (
                <div className={styles.overSpin}>
                    <Spin size="large" />
                </div>
            )
        }
        const flags = this.props.flags
        return (
            <React.Fragment>
                <div className={cn(styles.filterItem, styles.overPoints, compStyles.sliderWrapper)}>
                    <span className={styles.itemTitle}>Points</span>
                    <Nouislider
                        onChange={this.onRangeChange("points_on_contract", rangeMaxValues.points_on_contract)}
                        start={[this.filters.points_on_contract_gte, this.filters.points_on_contract_lte]}
                        tooltips={this.formatter}
                        connect
                        step={5}
                        behaviour={"tap-drag"}
                        range={{
                            min: 20,
                            "80%": [300, 5],
                            "90%": [600, 5],
                            max: 1600
                        }}
                    />
                    <div className={styles.minValue} ref={this.minRef} />
                    <div className={styles.maxValue} ref={this.maxRef} />
                </div>
                <div className={cn(compStyles.sliderWrapper, styles.filterItem)}>
                    <span className={styles.itemTitle}>Max Price Per Point</span>
                    <Nouislider
                        onChange={this.onRangeChange("price_per_point", rangeMaxValues.price_per_point)}
                        start={this.filters.price_per_point_lte}
                        behaviour={"tap-drag"}
                        step={5}
                        {...ppStatic}
                    />
                </div>
                <div className={cn(compStyles.sliderWrapper, styles.filterItem)}>
                    <span className={styles.itemTitle}>Max Contract Price</span>
                    <Nouislider onChange={this.onRangeChange("price", rangeMaxValues.price)} start={this.filters.price_lte} behaviour={"tap-drag"} step={5000} {...pStatic} />
                </div>
                <div className={cn(styles.starContainer, styles.filterItem)}>
                    <div className={styles.itemTitle}>Deal Score</div>
                    <StarsSelect onChange={this.onStarsChange} defaultValue={this.stars} />
                </div>
                {!this.props.resort && <TagsList width={280} withGroups items={this.resortNames} onItemChange={this.onListChangeResort} title="Resort" />}
                <TagsList items={this.use_month} onItemChange={this.onTagListChange("use_month")} title="Use Year" />
                <TagsList items={this.listing_status} onItemChange={this.onTagListChange("listing_status")} title="Status" />
                {flags[FEATURE_FLAGS.brokerStatus] && <TagsList items={this.broker_status} onItemChange={this.onTagListChange("broker_status")} title="Broker Status" />}
                <TagsList items={this.origin} onItemChange={this.onTagListChange("origin")} title="Resale Broker" />
                <div className={styles.overInactive}>
                    <label htmlFor="inactiveCheck">Show inactive listings</label>
                    <Toggle id="inactiveCheck" checked={!this.state.activeOnly} onChange={this.onInactiveChange} className={styles.inactiveCheckbox} />
                </div>
            </React.Fragment>
        )
    }
    onClosDrawer = () => {
        this.setState({
            open: false
        })
    }

    render() {
        const filters = this.getFilterContent()
        const open = this.state.open
        return (
            <>
                {open && <div className={styles.asideClose} onClick={this.onClosDrawer} />}
                <div className={styles.aside} data-open={open}>
                    <div className={styles.asideSpacing}>
                        <div className={styles.titleWrapper}>
                            <Title level={2} onClick={this.onClosDrawer} className={styles.title}>
                                <ArrowLeft />
                                Filter<span>by category</span>
                            </Title>
                            <button onClick={this.clearAll} type="link" className={styles.resetFiltersBtn}>
                                clear all
                            </button>
                        </div>
                        {filters}
                    </div>
                    <div className={styles.expand} />
                    <div className={styles.filterBottomBtns}>
                        <button onClick={this.clearAll} className={styles.resetAllBtn}>
                            Reset all
                        </button>
                        <button onClick={this.onClosDrawer} className={styles.seeListingsBtn}>
                            See {this.props.total} listings
                        </button>
                    </div>
                </div>
            </>
        )
    }
}

function useHooksToProps() {
    const router = useRouter()

    return {
        router,
        flags: useFlags()
    }
}

// Export the wrapped component
export default withHooksToProps(ListingsFilter, useHooksToProps)

const ppStatic = {
    connect: [true, false],
    tooltips: [{ to: formatTooltip(300) }],
    range: {
        min: 50,
        max: 305
    }
}

const pStatic = {
    connect: [true, false],
    tooltips: [{ to: formatTooltip(rangeMaxValues.price) }],
    range: {
        min: 5000,
        max: 55000
    }
}
